import React, { Component } from 'react';
import Login from "../views/login";
class LoginContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <Login></Login>
         );
    }
}
 


export default LoginContainer;